/* unplugin-vue-components disabled */// extracted by extract-css-chunks-webpack-plugin
module.exports = {"ContactsButton":"ContactsButton_d07ON","contactsContent":"contactsContent_iv43r"};